import classNames from 'classnames';
import React from 'react';
import Row from '../../components/Row/Row';
import Align from '../../types/enum/Align';
import Justify from '../../types/enum/Justify';
import Size from '../../types/enum/Size';
import './Bar.scss';
import IBarProps from './BarProps';

const Bar = ({ justify, align, size, children, className }: IBarProps) => {
  const classes = classNames(
    {
      bar: true,
      [`bar-${size}`]: true,
    },
    className
  );

  return (
    <Row align={align} justify={justify} className={classes}>
      {children}
    </Row>
  );
};

Bar.defaultProps = {
  justify: Justify.SPACE_BETWEEN,
  align: Align.CENTER,
  size: Size.MEDIUM,
};

export default Bar;
